'use strict';

import React, { Component } from 'react';
import Layout from 'Layouts/Front';
import Button from '@material-ui/core/Button';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import TextInput from 'Components/Forms/Elements/TextInput';
import Loader from 'Pure/Loader';
import Logo from 'Pure/Logo';
import Link from 'Pure/Link';
import { front_urls, URL } from 'Shared/Routes';
let app = typeof window !== 'undefined' ? window.app : undefined;
const qwest = typeof window !== 'undefined' ? window.qwest : undefined;
export default class ForgottenPasswordPage extends Component {
  state = {
    status_messages: {}
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    let pathname = document.location.pathname;
    if (pathname.endsWith('/')) pathname = pathname.slice(0, -1);
    const token = pathname.slice(pathname.lastIndexOf('/') + 1);
    if (!token) {
      return component.setState({
        invalid: true,
        error: 'Lien invalide ou expiré.'
      });
    }
    component.setState({
      invalid: false,
      token: token,
      error: undefined
    });
    qwest.post('/token/verify-password-recovery-token', {
      token: token
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  }
  handleChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages[name];
    component.setState({
      [name]: value,
      error: undefined,
      status_messages: status_messages
    });
  };
  requestPassword = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.password !== state.password_confirmation) {
      return component.setState({
        error: 'Les champs doivent concorder.'
      });
    }
    component.setState({
      loading: true
    });
    qwest.post('/user/new-password', {
      password: state.password,
      token: state.token
    }).then(function (xhr, response) {
      component.setState({
        info: 'Votre mot de passe a été modifié avec succès, ' + 'vous pouvez dès maintenant l\'utiliser pour vous connecter.',
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const message = getFormStatus(state);
    let loader;
    if (state.loading === true) {
      loader = /*#__PURE__*/React.createElement(Loader, {
        className: "c-loader",
        bemit: ['white', 'bg-primary']
      });
    }
    let submit;
    if (!state.info && !state.invalid) {
      submit = /*#__PURE__*/React.createElement("div", {
        className: "u-full-width u-margin-top-25\r u-padding-bottom-20 u-text-center"
      }, /*#__PURE__*/React.createElement(Button, {
        color: "primary",
        variant: "contained",
        size: "large",
        onClick: component.requestPassword
      }, "Valider", loader));
    } else if (!state.invalid) {
      submit = /*#__PURE__*/React.createElement("div", {
        className: "u-full-width u-margin-top-25\r u-padding-bottom-20 u-text-center"
      }, /*#__PURE__*/React.createElement(Button, {
        color: "secondary",
        size: "small",
        href: URL('HomePage', front_urls),
        component: Link
      }, "Page de connexion", loader));
    }
    let output = /*#__PURE__*/React.createElement(Layout, props, /*#__PURE__*/React.createElement("div", {
      className: "simple-page u-positioned"
    }, /*#__PURE__*/React.createElement("div", {
      className: "o-content",
      style: {
        width: '450px',
        maxWidth: '100%',
        marginBottom: '120px',
        marginTop: 120
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "u-text-center u-margin-bottom-30"
    }, /*#__PURE__*/React.createElement(Link, {
      className: "auth-logo-link",
      href: URL('Login', front_urls)
    }, /*#__PURE__*/React.createElement(Logo, {
      style: {
        width: '240px',
        maxWidth: '100%',
        margin: 'auto'
      }
    }))), /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['password'],
      name: "password",
      type: "password",
      label: "Nouveau mot de passe",
      status: state.status_messages
    }), /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['password_confirmation'],
      name: "password_confirmation",
      type: "password",
      label: "Confirmation de mot de passe",
      status: state.status_messages
    }), message, submit)));
    return output;
  }
}
